import { Router } from '@angular/router';
import { NavService } from './../../navigation/nav.service';
import { Component, Input, Inject } from '@angular/core';
import { NavigationElement } from '../../navigation/nav.service';
import { L10nLocale, L10N_LOCALE } from 'angular-l10n';

@Component({
  selector: 'app-nav-element',
  templateUrl: './nav-element.component.html',
  styleUrls: ['./nav-element.component.scss'],
  standalone: false
})
export class NavElementComponent {
  @Input() element: NavigationElement;
  @Input() level: number;
  @Input() nested: boolean;

  get isInRoute(): boolean {
    return this.isInRouteRecursive(this.element);
  }

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private navService: NavService,
    private route: Router
  ) {}

  isElementAllowed(navElement: NavigationElement): boolean {
    return this.navService.isAllowed(navElement);
  }

  isInRouteRecursive(navElement: NavigationElement): boolean {
    if (this.route.url.includes(navElement.route)) {
      return true;
    }

    let isInRoute = false;
    navElement.elements?.forEach((child) => {
      isInRoute = isInRoute || this.isInRouteRecursive(child);
    });

    return isInRoute;
  }

  getPadding() {
    return (this.level >= 1 ? this.level * 8 : 0) + 'px';
  }
}
